import React from 'react';
import './App.css';
import Content from './components/layout/Content';

function App() {
  return (
    <div>
      <Content />
    </div>
  );
}

export default App;
